import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { BellOff, ArrowLeft } from "lucide-react";
import api, { apiError } from "@/lib/api";
import Layout from "@/components/Layout";

export default function UnsubscribePage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("idle"); // idle | loading | ok | error
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setErr("Chybí ověřovací token.");
      return;
    }
    let cancel = false;
    (async () => {
      setStatus("loading");
      try {
        await api.get(`/watchers/unsubscribe?token=${encodeURIComponent(token)}`);
        if (!cancel) setStatus("ok");
      } catch (e) {
        if (!cancel) {
          setErr(apiError(e));
          setStatus("error");
        }
      }
    })();
    return () => {
      cancel = true;
    };
  }, [token]);

  return (
    <Layout>
      <div className="stb-card p-8 max-w-xl mx-auto text-center" data-testid="unsubscribe-page">
        <BellOff size={42} className="mx-auto text-[#FF6B00]" />
        {status === "loading" && (
          <p className="text-white mt-4">Ruším sledování…</p>
        )}
        {status === "ok" && (
          <>
            <h1 className="stb-h text-2xl text-white mt-3">Sledování zrušeno</h1>
            <p className="text-[#A3A3A3] mt-2">
              Už ti k tomuto sledování nepřijde žádný e-mail.
            </p>
          </>
        )}
        {status === "error" && (
          <>
            <h1 className="stb-h text-2xl text-white mt-3">Nepodařilo se odhlásit</h1>
            <p className="text-[#A3A3A3] mt-2">{err || "Zkus prosím odkaz z e-mailu znovu."}</p>
          </>
        )}
        <Link to="/" className="stb-btn stb-btn-primary mt-4 inline-flex">
          <ArrowLeft size={14} /> Zpět na inzeráty
        </Link>
      </div>
    </Layout>
  );
}
